// Lesson 4: Kata Ganti & Kalimat Dasar - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 4: Kata Ganti & Kalimat Dasar (Pronouns & Basic Sentences)
export const unit1Lesson4ExtendedWordBank: Word[] = [
    {
        id: 101,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 102,
        batak: "ᯂᯬ",
        latin: ["ho"],
        indonesia: "Kamu",
        syllable_mapping: [
            { batak_char: "ᯂᯬ", latin: "ho" }
        ]
    },
    {
        id: 103,
        batak: "ᯤᯀ",
        latin: ["i", "a"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
    {
        id: 104,
        batak: "ᯂᯫᯤ",
        latin: ["ha", "mi"],
        indonesia: "Kami",
        syllable_mapping: [
            { batak_char: "ᯂ", latin: "ha" },
            { batak_char: "ᯫᯤ", latin: "mi" }
        ]
    },
    {
        id: 105,
        batak: "ᯂᯔᯮ",
        latin: ["ha", "mu"],
        indonesia: "Kalian",
        syllable_mapping: [
            { batak_char: "ᯂ", latin: "ha" },
            { batak_char: "ᯔᯮ", latin: "mu" }
        ]
    },
    // Words needed for questions
    {
        id: 106,
        batak: "ᯔᯀᯒᯖᯬᯉᯮᯉ᯲",
        latin: ["mar", "to", "nun"],
        indonesia: "berasal",
        syllable_mapping: [
            { batak_char: "ᯔᯀᯒ", latin: "mar" },
            { batak_char: "ᯖᯬ", latin: "to" },
            { batak_char: "ᯉᯮᯉ᯲", latin: "nun" }
        ]
    },
    {
        id: 107,
        batak: "ᯖᯀᯒᯮᯖᯮᯰ",
        latin: ["ta", "ru", "tung"],
        indonesia: "Tarutung",
        syllable_mapping: [
            { batak_char: "ᯖᯀ", latin: "ta" },
            { batak_char: "ᯒᯮ", latin: "ru" },
            { batak_char: "ᯖᯮᯰ", latin: "tung" }
        ]
    },
    {
        id: 108,
        batak: "ᯀᯍ",
        latin: ["a", "ha"],
        indonesia: "Apa",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯍ", latin: "ha" }
        ]
    },
    {
        id: 109,
        batak: "ᯀᯉᯃᯒᯉ᯲",
        latin: ["a", "nak", "kon"],
        indonesia: "nama",
        syllable_mapping: [
            { batak_char: "ᯀ", latin: "a" },
            { batak_char: "ᯉᯃ", latin: "nak" },
            { batak_char: "ᯒᯉ᯲", latin: "kon" }
        ]
    },
    // Additional words from previous lessons used in this context
    {
        id: 110,
        batak: "ᯇᯀᯒᯎᯮᯒᯬᯉ᯲",
        latin: ["par", "gu", "ron"],
        indonesia: "Pelajar",
        syllable_mapping: [
            { batak_char: "ᯇᯀᯒ", latin: "par" },
            { batak_char: "ᯎᯮ", latin: "gu" },
            { batak_char: "ᯒᯬᯉ᯲", latin: "ron" }
        ]
    },
    {
        id: 111,
        batak: "ᯎᯮᯒᯮ",
        latin: ["gu", "ru"],
        indonesia: "Guru",
        syllable_mapping: [
            { batak_char: "ᯎᯮ", latin: "gu" },
            { batak_char: "ᯒᯮ", latin: "ru" }
        ]
    },
    {
        id: 112,
        batak: "ᯑᯬ",
        latin: ["do"],
        indonesia: "adalah",
        syllable_mapping: [
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 113,
        batak: "ᯑᯬ",
        latin: ["do"],
        indonesia: "dari",
        syllable_mapping: [
            { batak_char: "ᯑᯬ", latin: "do" }
        ]
    },
    {
        id: 999,
        batak: "",
        latin: ["."],
        indonesia: "",
        syllable_mapping: [{ batak_char: "", latin: "-" }],
    },
];

// Helper function to create word dictionary
export const createUnit1Lesson4WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
